import styled from "styled-components";
import { colors, device } from "../../../theme";

const HeroText = styled.div.withConfig({
  displayName: "HeroText",
})`
  font-weight: 800;
  font-size: 30px;
  text-align: center;
  color: ${({ color }: { color?: string }) => color || colors.white};

  @media ${device.mobileL} {
    font-size: 35px;
  }

  @media ${device.tablet} {
    font-size: 70px;
  }

  @media ${device.laptop} {
    font-size: 94px;
  }
`;

export default HeroText;
